/**
 * Filtros de una fuente: recortan la hoja antes de gráficos, uniones y esquema.
 */
import React from 'react';
import { studio, ink } from '../studioUi';
import FilterRuleCard from './FilterRuleCard';
import { createSourceFilter } from './filterUtils';
import { sourceRequestFields } from './engineConfig';

export default function SourceFiltersPanel({
    source,
    columns = [],
    dataSources = [],
    joins = [],
    onChange,
    compact = false,
}) {
    if (!source) return null;
    const filters = source.filters || [];

    const patch = (filterId, partial) => {
        onChange(filters.map((item) => (item.id === filterId ? { ...item, ...partial } : item)));
    };

    const addFilter = (columnName) => {
        const colMeta = columns.find((col) => col.name === columnName) || { name: columnName, inferred_type: 'string' };
        onChange([...filters, createSourceFilter(colMeta)]);
    };

    return (
        <div style={compact ? ui.wrapCompact : ui.wrap}>
            <div style={compact ? ui.headCompact : ui.head}>
                <span style={studio.kicker}>Recorte al cargar</span>
                {!compact && <span style={ui.hint}>Solo esta fuente. No sustituye los filtros del informe.</span>}
                {columns.length > 0 && (
                    <select
                        value=""
                        onChange={(e) => {
                            if (e.target.value) addFilter(e.target.value);
                        }}
                        style={compact ? ui.addCompact : ui.add}
                    >
                        <option value="">+ Campo…</option>
                        {columns.map((col) => (
                            <option key={col.name} value={col.name}>{col.name}</option>
                        ))}
                    </select>
                )}
            </div>
            {filters.length === 0 && (
                <p style={compact ? ui.emptyCompact : ui.empty}>Sin recorte: se cargan todas las filas de la hoja.</p>
            )}
            {filters.map((item) => {
                const valueSource = sourceRequestFields(source, {
                    dataSources: dataSources.map((row) => (row.id === source.id
                        ? { ...row, filters: filters.filter((entry) => entry.id !== item.id) }
                        : row)),
                    joins,
                }, { includeSelection: false });
                return (
                    <FilterRuleCard
                        key={item.id}
                        item={item}
                        columns={columns}
                        dataSource={valueSource}
                        showColumn
                        compact={compact}
                        onChange={(partial) => patch(item.id, partial)}
                        onRemove={() => onChange(filters.filter((entry) => entry.id !== item.id))}
                    />
                );
            })}
        </div>
    );
}

const ui = {
    wrap: { display: 'flex', flexDirection: 'column', gap: 6 },
    wrapCompact: { display: 'flex', flexDirection: 'column', gap: 8 },
    head: { display: 'flex', flexDirection: 'column', gap: 2 },
    headCompact: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 10,
        flexShrink: 0,
    },
    hint: { fontSize: '0.7rem', color: ink.muted, lineHeight: 1.35 },
    empty: { margin: 0, fontSize: '0.72rem', color: ink.faint },
    emptyCompact: { margin: 0, fontSize: '0.78rem', color: ink.faint, lineHeight: 1.45 },
    add: {
        ...studio.controlCompact,
        maxWidth: 260,
        minHeight: 30,
        height: 30,
        padding: '4px 12px',
        borderRadius: 999,
        fontSize: '0.78rem',
    },
    addCompact: {
        ...studio.controlCompact,
        width: 'auto',
        maxWidth: 140,
        minHeight: 28,
        height: 28,
        padding: '2px 10px',
        borderRadius: 999,
        fontSize: '0.72rem',
        flexShrink: 0,
    },
};
